import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";


export class NormalBet implements FlowStatePresentation {
    constructor() {
    }

    public start(flowStateController: FlowStateController) {

        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => flowStateController.finish()});
        const delay = XwaysHoarder2Statics.stepDuration;

        //changing spin reelset according to level
        XwaysHoarder2.reelView.changeReelSets(XwaysHoarder2.model.data.nextMode,XwaysHoarder2.model.data.nextFSLevel);

        if (XwaysHoarder2.model.gameData) {
            if (XwaysHoarder2.model.gameData.betWayWins.length > 0) {
                XwaysHoarder2.reelView.hideReelsNoWinOverlay();
            }
        }
        tl.add(() => {
            XwaysHoarder2.reelView.symbolsToNormalLayer();
        }, 0);


        XwaysHoarder2.reelView.reels.forEach((reel) => {
            reel.xnLandSoundPlayed = false;
        });

        /*   if(!XwaysHoarder2.model.isRestore && (XwaysHoarder2.model.data.mode !== XW2GameMode.FREESPIN && XwaysHoarder2.model.data.mode !== XW2GameMode.FREESPIN)) {
               [0, 1, 2, 3, 4, 5].forEach((rId) => {
                   XwaysHoarder2.reelView.reels[rId].resetMergeHasRun();
               });
           }*/
        // Add start animatio
        //tl.add(XwaysHoarder2.globalMultiplier.setMultiplier(1));
        tl.add(() => {
            XwaysHoarder2Sound.shuffleReelLanding();
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.REELS_SPINNING, 1, Number.MAX_VALUE);
        }, 0);
        tl.add(XwaysHoarder2.reelView.reels[0].model.start(false), 0);
        tl.add(XwaysHoarder2.reelView.reels[1].model.start(false), delay);
        tl.add(XwaysHoarder2.reelView.reels[2].model.start(false), delay * 2);
        tl.add(XwaysHoarder2.reelView.reels[3].model.start(false), delay * 3);
        tl.add(XwaysHoarder2.reelView.reels[4].model.start(false), delay * 4);
        tl.add(XwaysHoarder2.reelView.reels[5].model.start(false), delay * 5);

        tl.add(() => {
            XwaysHoarder2.waysCounter.reduceToDefault()
        }, 0);
        /*   tl.add(()=>{
               XwaysHoarder2.reelView.reels.forEach((reel:Reel,index:number)=>{
                   reel.stickySymbolsLayerUp();
               })
           },0)*/
    }
}